import Sidebar from './customer/Sidebar'
import OrderUpdateBanner from './OrderUpdateBanner'
import Footer from './Footer'
import DashHeader from './DashHeader'
import Chat from './customer/chat/Chat'
import TempSelection from './customer/TempSelecion'
import { MdOutlineChatBubbleOutline } from "react-icons/md";
import { FaBasketShopping } from "react-icons/fa6";
import { getTotalUnreadMessageCount } from '../services/chatService'
import '../style/layout.css'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { checkoutSetOpen } from '../features/checkoutSlice'
import { useLocation } from 'react-router-dom'
const RouteLayout = ({children}) => {
    const [openChat, setOpenChat] = useState(false)
    const [unreadMessages, setUnreadMessages] = useState(0)
    const [basketItems, setBasketItems] = useState(0)
    const dispatch = useDispatch()
    const user = useSelector((state) => state.login.data)
    const basket = useSelector((state) => state.checkout.items)
    const openBasket = useSelector((state) => state.checkout.isOpen)
    const isCollector = user?.role === 'COLLECTOR'
    const token = user ? user.token : null
    const location = useLocation()
    // Basket doesn't apply on the delivery dashboard (admin/facility-admin map view)
    const hideBasket = location.pathname === '/delivery-dashboard'
    // Chat moves to the left edge while the checkout box is open, and snaps back when it closes
    const chatAside = openBasket && !hideBasket
    const getUnreadCount = async (token) => {
        const data = await getTotalUnreadMessageCount(token)
        // console.log('unread messages: ',data.unread)
        setUnreadMessages(data.unread)
    }
    const getBasketItemCount = () => {
        setBasketItems(basket.length)
    }
    useEffect(() => {
        getBasketItemCount()
    }, [basket])
    useEffect(() => {
        if(!token) return
        getUnreadCount(token)
    },[])
    return(
        <div className='layout'>
            <OrderUpdateBanner />
            {openChat && <Chat className={`fixed bottom-10 z-40 ${chatAside ? 'left-10' : 'right-10'}`} onClose={()=>setOpenChat(false)}/>}
            <DashHeader />
            <main className='flex-1 relative'>
                {children}
                <div onClick={()=>setOpenChat(true)} className='right-4 bottom-4 fixed z-40 transition-all duration-300 ease-out' style={chatAside ? { right: 'calc(100% - 5rem)' } : undefined}>
                    <div className='bg-gradient-to-r from-[#1a7071] to-[#26c5c7] rounded-full p-4 shadow-md flex items-center justify-center cursor-pointer relative'>
                        <MdOutlineChatBubbleOutline className='text-white font-semibold w-8 h-8'/>
                        {unreadMessages > 0 && <div className='absolute bg-red-500 rounded-full p-1 h-5 w-5 md:h-7 md:w-7 right-[-3px] top-[-3px] flex items-center justify-center'>
                                <p className='text-white text-sm md:text-base'>{unreadMessages}</p>
                            </div>}
                    </div>
                </div>
                {!hideBasket && (
                    <>
                        <div onClick={()=>dispatch(checkoutSetOpen(!openBasket))} className='right-4 bottom-28 fixed z-40'>
                            <div className='bg-gradient-to-r from-[#1a7071] to-[#26c5c7] rounded-full p-4 shadow-md flex items-center justify-center cursor-pointer relative'>
                                <FaBasketShopping className='text-white h-8 w-8' />
                                {basketItems > 0 && !isCollector && <div className='absolute bg-red-500 rounded-full p-1 h-5 w-5 md:h-7 md:w-7 right-[-3px] top-[-3px] flex items-center justify-center'>
                                        <p className='text-white text-sm md:text-base'>{basketItems}</p>
                                    </div>}
                            </div>
                        </div>
                        <div className="w-auto h-auto z-50 fixed">
                                <TempSelection open={openBasket} close={() => dispatch(checkoutSetOpen(false))} />
                        </div>
                    </>
                )}
            </main>
            <Sidebar />
            <Footer />
        </div>
    )
}
export default RouteLayout
